import {CardTypeContainers} from "./CardTypeComponentLists";

export class SellerListCard{

    constructor(sellerData, {experiments, cardType = 'primary'}) {
        this.sellerData = sellerData;
        this.containers = this.buildContainers(cardType, experiments);
        this.template = Handlebars.compile(document.getElementById(`${cardType}-list-card-template`).innerHTML);
    }

    buildContainers = (cardType='primary', experiments) => {
        return new CardTypeContainers(cardType, experiments);
    }

    outputCardHtml = () => {
        const componentContainers = this.containers.buildTemplateArgs(this.sellerData);
        const templateArgs = {
            ...componentContainers,
            ...this.sellerData,
        }
        return this.template(templateArgs);
    }

}
